import React, { useEffect, useState } from "react";
import { Box, TextField, Typography, Button, Container, Snackbar, Alert, Grid, Accordion, AccordionSummary, AccordionDetails,} from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, Autoplay} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import bg from '../assets/images/TKS-Slide_images.png';
import image from '../assets/images/Thirukadaiyur-Temple1-TKSTrust.jpg';
import Temple from '../assets/images/thirukadaiyur-abirami-temple_TKStrust.jpg';
import bg1 from '../assets/images/Slider-images-TSCT1.jpg';
import sq from '../assets/images/Rectangle-2.png';
import br from '../assets/images/bottom.png';
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import contact from "../assets/images/Thirukadaiyur-Temple-TKSTrust.jpg";
import emailjs from "@emailjs/browser";
  function Home() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash === "#faq-section") {
      const faqElement = document.getElementById("faq-section");
      if (faqElement) {
        faqElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    location: "",
    message: "",
  });
  
  const [errors, setErrors] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  
  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "name") {
      // Allow only letters and spaces (no numbers or special characters)
      const regex = /^[A-Za-z\s]*$/;
      if (!regex.test(value)) return;
    }
  
    if (name === "phone") {
      // Allow only numbers, limit to 10 digits
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData({ ...formData, [name]: numericValue });
      return;
    }
  
    setFormData({ ...formData, [name]: value });
  };
  
  // Form Validation (No Browser Popups)
  const validateForm = () => {
    let newErrors = {};
  
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone Number is required";
    else if (!/^\d{10}$/.test(formData.phone))
      newErrors.phone = "Enter a valid 10-digit phone number";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Enter a valid email address";
    if (!formData.location.trim()) newErrors.location = "Location is required";
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
    // Handle Form Submission (Send Email)
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!validateForm()) return;
  
      try {
        const response = await emailjs.send(
          "service_rwy243e", // Replace with your EmailJS Service ID
          "template_fku0av9", // Replace with your EmailJS Template ID
          formData,
          "WUZpZph-Cfam5LiSJ" // Replace with your EmailJS Public Key
        );
  
        if (response.status === 200) {
          setOpenSnackbar(true);
          setFormData({ name: "", phone: "", email: "", location: "", message: "" });
        } else {
          setErrorSnackbar(true);
        }
      } catch (error) {
        console.error("EmailJS Error:", error);
        setErrorSnackbar(true);
      }
    };
  return (
    
  <Box sx={{ backgroundColor: "#f8f9e9"}}>
   {/* Hero Section */}
      <Box
        sx={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: "80vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "white",
          position: "relative",
        }}
      >
        {/* Overlay for better readability */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          }}
        />
  
        <Typography 
          variant="h3" 
          sx={{ fontWeight: "bold", zIndex: 1, color: "#FFCC03" }}
        >
          Thirukadaiyur Senaithalaivar Charitable Trust
        </Typography>
        
        <Typography 
          variant="h4" 
          sx={{ fontWeight: "bold", zIndex: 1, marginTop: 2, color: "white" }}
        ><br />
          Join us for <span style={{ color: "white" }}>Collective Progress!</span>
        </Typography>
      </Box>


      {/* About Us section */}
<Box sx={{ backgroundColor: "#f8f9e9", py: 6, position: "relative", overflow: "hidden" }}>
  
  {/* Yellow Shape - Positioned Absolutely */}
  <Box
  sx={{
    position: "absolute",
    top: "0",
    left: "0",
    width: "250px", 
    height: "600px",
    backgroundImage: `url(${sq})`,
    backgroundSize: "contain", 
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
  }}
/>



  <Container sx={{ position: "relative", zIndex: 1 }}>
    <Grid container spacing={4} alignItems="center">
      
      {/* 1️⃣ Heading - First on Mobile */}
      <Grid item xs={12} sx={{ display: { xs: "block", md: "none" }, textAlign: "center" }}>
        <Typography variant="h3" sx={{ fontWeight: "700", color: "red", textAlign: "center", fontSize: "50px"  }}>
        About <span style={{ color: "#FAD707" }}>Us</span>
  </Typography>
      </Grid>

      {/* 2️⃣ Image Section - Right on Desktop, Above on Mobile */}
      <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
        <Box
          component="img"
          src={image} // Ensure "image" is correctly imported
          alt="Temple"
          sx={{
            width: "100%",
            maxWidth: "400px",
            display: "block",
            margin: "0 auto",
            borderRadius: "8px",
            boxShadow: 2,
          }}
        />
      </Grid>

      {/* 3️⃣ Content Section - Left on Desktop, Below Image on Mobile */}
      <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
        {/* Heading - Visible on Desktop Only */}
        <Typography
          variant="h2"
          sx={{
            fontWeight: "700", color: "red", textAlign: "center", fontSize: "50px",
            display: { xs: "none", md: "block" },
          }}
        >
          About <span style={{ color: "#FAD707" }}>Us</span>
        </Typography>

        {/* Swiper Carousel with Correct Button Placement */}
        <Box sx={{ position: "relative" }}>
          <Swiper
            navigation={{
              prevEl: ".custom-prev-about",
              nextEl: ".custom-next-about",
            }}
            autoplay={{ delay: 11000, disableOnInteraction: false }}
            loop={true}
            modules={[Navigation, Autoplay]}
            className="swiper-container"
          >
            <SwiperSlide>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontSize: "18px",
                  color: "black",
                  lineHeight: 2.0,
                  fontWeight: 500,
                  textAlign: "justify",
                  px: { xs: 3, md: 5 }, // Adjusted padding for readability
                }}
              >
                Welcome to Thirukadaiyur Charitable Trust, a non-profit organization 
                committed to uplifting and supporting individuals through various 
                initiatives focused on education, marriage, and social welfare.
                Our mission is to empower underprivileged individuals by providing 
                scholarships, organizing mass marriages, and offering financial support 
                for community development.
              </Typography>
            </SwiperSlide>

            <SwiperSlide>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontSize: "18px",
                  color: "black",
                  fontWeight: 500,
                  lineHeight: 2.0,
                  textAlign: "justify",
                  px: { xs: 3, md: 5 }, // Adjusted padding for better readability
                }}
              >
                திருக்கடையூர் அறக்கட்டளைக்கு வரவேற்கிறோம், கல்வி உதவித்தொகை, 
                வெகுஜன திருமணங்களை ஏற்பாடு செய்தல் மற்றும் சமூக மேம்பாட்டிற்கு 
                நிதியுதவி வழங்குவதன் மூலம் ஒற்றுமை, சமத்துவம் மற்றும் செழிப்பை 
                வளர்ப்பதே எங்கள் நோக்கம்.
              </Typography>
            </SwiperSlide>
          </Swiper>

          {/* Custom Navigation Buttons - Inside the Box for Correct Positioning */}
          <button
  className="custom-prev-about"
  style={{
    position: "absolute",
    top: "50%",
    left: "-10px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❮
</button>

<button
  className="custom-next-about"
  style={{
    position: "absolute",
    top: "50%",
    right: "-10px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❯
</button>
        </Box>
        {/* More Info Button */}
<Button
  variant="contained"
  sx={{
    mt: 3,
    backgroundColor: "red",
    color: "white",
    fontWeight: "bold",
    textTransform: "none",
    px: 3,
    "&:hover": { backgroundColor: "#c40000" },
  }}
  endIcon={<ArrowForwardIcon sx={{ ml: 1 }} />}
  onClick={() => {
    navigate("/aboutus");
    window.scrollTo(0, 0); 
  }}
>
  More Info
</Button>

      </Grid>

    </Grid>
  </Container>
</Box>


<Box id="our-people-section" sx={{ backgroundColor: "#f8f9e9", py: 6 }}>
  
  <Typography variant="h3" sx={{ fontWeight: "700", color: "red", textAlign: "center", fontSize: "50px"  }}>
  Our <span style={{ color: "#FAD707" }}>People</span>
  </Typography>

  <Typography
    variant="body1"
    sx={{
      mt: 2,
      fontSize: "18px",
      color: "#000000",
      lineHeight: 1.8,
      fontWeight: "500",
      textAlign: "justify",
      px: { xs: 3, md: 25 }, 
    }}
    gutterBottom
  >
    Our trust proudly serves everyone, emphasizing unity, welfare, and progress. 
    We aim to uplift members by addressing critical needs, including education,
    cultural preservation, and infrastructure development. Our initiatives are 
    designed to honor our heritage while embracing the future with a vision of 
    shared prosperity.
  </Typography>

  <Typography
    variant="body2"
    sx={{
      mt: 2,
      fontSize: "18px",
      color: "#000000",
      lineHeight: 1.8,
      fontWeight: "500",
      textAlign: "justify",
      px: { xs: 3, md: 25 },
    }}
    gutterBottom
  >
    ஒற்றுமை பொதுநல மற்றும் முன்னேற்றத்தை வலியுறுத்தி எங்கள் அறக்கட்டளை பெருமையுடன்
     சேவை செய்கிறது கல்வி கலாச்சாரம் பாதுகாப்பு மற்றும் உள்கட்டமைப்பு மேம்பாடு உள்ளிட்ட 
     முக்கியமான தேவைகளை நிவர்த்தி செய்வதன் மூலம் எங்கள் உறுப்பினர்களை மேம்படுத்துவதை 
     நோக்கமாக நாங்கள் கொண்டுள்ளோம் எங்கள் முன் முயற்சிகள் நமது பாரம்பரியத்தையும் மதிக்கும்
    வகையில் வடிவமைக்கப்பட்டுள்ளது. அதே நேரத்தில் தற்போதைய காலகட்டத்திற்கு உகந்ததாக இருக்கும்.


  </Typography>
</Box>

    
  {/*Cultural Heritage Temples section */}

  <Box sx={{ backgroundColor: "#f8f9e9", py: 6 }}>
  <Container>
    <Grid container spacing={4} alignItems="center">
      
      {/* 1️⃣ Heading - Always First on Mobile */}
      <Grid item xs={12} sx={{ display: { xs: "block", md: "none" }, textAlign: "center" }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", color: "red" }}>
          Cultural Heritage <span style={{ color: "#FAD707" }}>Temples</span>
        </Typography>
      </Grid>

      {/* 2️⃣ Left Image Section (Image moves below heading on mobile) */}
      <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
        <Box
          component="img"
          src={Temple}
          alt="Tks_trust_Temple"
          sx={{
            width: "100%",
            borderRadius: "8px",
            boxShadow: 3,
          }}
        />
      </Grid>

      {/* 3️⃣ Right Text Section (Content moves below image on mobile) */}
      <Grid item xs={12} md={6} order={{ xs: 3, md: 2 }}>
        {/* Heading - Only Visible in Desktop View */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "red",
            display: { xs: "none", md: "block" },
          }}
        >
          Cultural Heritage <span style={{ color: "#FAD707" }}>Temples</span>
        </Typography>

        {/* Swiper Content */}
        <Box sx={{ position: "relative" }}>
          <Swiper
            navigation={{
              prevEl: ".custom-prev",
              nextEl: ".custom-next",
            }}
            autoplay={{ delay: 100000, disableOnInteraction: false }}
            loop={true}
            modules={[Navigation, Autoplay]}
            className="swiper-container"
          >
          <SwiperSlide>
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "14px",
                color: "#000000",
                fontWeight: 500,
                lineHeight: 2.3,
                textAlign: "justify",
                px: { xs: 2, md: 5 }, // Padding for better readability
              }}
            >
              Arulmigu Neelayatakshi Udanurai Sri Kalakaleswarar Temple, Erukattancherry (Mayiladuthurai District) <br  /><br  />
                 Sri Mrikandu Muni and his wife, yearning for a child, performed intense penance to Lord Shiva. Moved by their devotion, 
                 Lord Shiva blessed them with a son, albeit with a short lifespan of only 16 years. The couple was soon blessed with a son, 
                 whom they named Markandeya. Aware of his limited life, Markandeya devoted himself to worshipping Lord Shiva daily at Thirukkadaiyur.<br  /><br  />
                 On the day Markandeya completed his 16th year, while immersed in worship, Yama (the god of death) cast his noose of affection, 
                 which mistakenly fell on Lord Shiva. Enraged by this act, Lord Shiva rose as Kalasamharamurthy and destroyed Yama at a place 
                 called Erukattancherry, named after the abundance of Erukkanchedi flowers in Thirukkadaiyur. <br  /><br  />
                 Distressed by the imbalance on earth due to Yama’s demise, Bhoomadevi (Goddess Earth) prayed to Lord Shiva. Compassionately,
                  the Lord revived Yama, bestowed blessings upon him, and forgave his actions. Yama, repentant, worshiped Lord Shiva and resumed his duties.<br  /><br  />
                 The Lord, who manifested as Kalasamharamurthy to save Yama, continues to bless devotees here as Kalakala Ishwarar. This sacred place 
                 is believed to bestow longevity and fulfillment upon devotees who perform rituals such as Shashti Abta Purti, Sadabhishekam, and Ayush Homam.
            </Typography>
          </SwiperSlide>

          <SwiperSlide>
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "14px",
                color: "#000000",
                fontWeight: 500,
                textAlign: "justify",
                px: { xs: 2, md: 5 }, // Adjust padding for better readability
              }}
            >
              அருள்மிகு நீலாயதாட்சி உடனுறை ஸ்ரீ காலகாலேஸ்வரர் ஆலயம் எருக்கட்டாஞ்சேரி மயிலாடுதுறை மாவட்டம்<br  /><br  />
                  புராண வரலாறு ஸ்ரீ மிருகண்டு முனிவரும் அவர் மனைவியும் தமக்கு பிள்ளைவரம் வேண்டி சிவபெருமானை நோக்கி கடுந்தவம் புரிந்தனர். 
                  இறைவன் மனமிரங்கி அத்தம்பதியினருக்கு ஆண் மகவு பிறக்கும் என்றும் அது 16 வயது மட்டும் ஆயுள் உள்ளதாக இருக்கும் என்றும் வரமளித்தார். 
                  சில காலம் கழித்து அவர்களுக்கு ஆண் மகவு பிறந்து மார்க்கண்டேயர் என்று பெயரிட்டு வளர்த்து வந்தனர்.
                  ஸ்ரீ மார்க்கண்டேயரும் தனது சொற்ப ஆயுட்காலத்தை மனதில் கொண்டு திருக்கடையூரில் எழுந்தருளிய சிவபிரானை தினமும் 
                  மிகுந்த பக்தியோடு வழிபட்டு வந்தார். அப்படி தனது 16 வது  வயது பூர்த்தியாகும் நாளில் இறைவனை வழிபட்டு கொண்டிருக்கையில் எமதருமன்
                   அவர்மீது பாசக் கயிற்றை வீச அது இறைவன் மேலும் வீழ்ந்தது. இச்செயலைக் கண்டு வெகுண்டு எழுந்த இறைவன் எமதருமனை உதைத்து தள்ளி 
                   சம்ஹாரம் செய்ய எமதருமனின் சிரசு திருக்கடையூருக்கு தென்பால் எருக்கம்பூ நிறைந்த எருக்கட்டாஞ்சேரி என்னும் தலத்தில் வந்து வீழ்ந்தது.
                   <br  /><br  />இதனால் இறப்புத்தொழில் நின்று பூமிபாரம் தாங்க முடியாமல் ‘பூமாதேவி’ இங்கு எழுந்தருளியுள்ள ஈசனை பணிந்து வேண்ட 
                    இறைவன் மனமிரங்கி எமனை உயிர்பித்து அனுக்கிரஹம் செய்தருளினார். எமதருமனும் தனது தவறுக்கு வருந்தி ஈசனை 
                    வழிப்பட்டு தனது இறப்பு தொழிலுக்கு திரும்பினார்.
                  எமதருமனை நிக்ரஹம் செய்ய காலசம்ஹாரமூர்த்தியாக எழுந்த இறைவன் இத்தலத்தில் ஸ்ரீ கால கால ஈஸ்வரராக அனுக்கிரஹம் செய்து அருள்பாலிக்கிறார்.
                  எமதருமனுக்கு அனுக்கிரஹம் செய்த இத்தலத்தில் ஷஷ்டி அப்த பூர்த்தி, சதாபிஷேகம், ஆயுஸ் ஹோமம் முதலியன செய்ய நீண்ட ஆயுலும், 
                  நிறைவான வாழ்வும் உண்டாகும். 
            </Typography>
             </SwiperSlide>
        </Swiper>
        <button
  className="custom-prev"
  style={{
    position: "absolute",
    top: "50%",
    left: "-10px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❮
</button>

<button
  className="custom-next"
  style={{
    position: "absolute",
    top: "50%",
    right: "-10px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❯
</button>

        </Box>
      </Grid>

    </Grid>
    
  </Container>
  <Box
  sx={{
    position: "relative",
    left:"50%",
    width: "40%",
    height: { xs: "80px", md: "150px" }, // Smaller height on mobile, larger on desktop
    backgroundImage: `url(${br})`,
    backgroundSize: "cover", // Ensures full coverage on all screen sizes
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    marginTop: { xs: "-50px", md: "-100px" }, // Adjusts placement for mobile & desktop
    zIndex: 0, // Ensures it stays below content
  }}
/>

</Box>

     {/* Invite Section */}
<Box
  sx={{
    p: 2,
    backgroundColor: "#f8f9e9",
    backgroundImage: `url(${bg1})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    py: { xs: 4, md: 6 }, // Adjusted padding for small screens
    width: "100%",
    maxWidth: "75%",
    minHeight: "60vh", // Adjusted for responsiveness
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center", // Ensures content is centered vertically
  }}
>
  <Box
    sx={{
      backgroundColor: "#FFFFFF99", // Adjusted transparency for better readability
      p: { xs: 3, md: 4 }, // Responsive padding
      borderRadius: 3,
      textAlign: "center",
      maxWidth: { xs: "95%", sm: "85%", md: "80%" }, // Adjust width based on screen size
      margin: "auto",
    }}
  >
    <Typography
      variant="h4"
      sx={{
        mt: 2,
        fontSize: { xs: "20px", sm: "24px", md: "32px" }, // Responsive text size
        color: "red",
        fontWeight: "700",
        textAlign: "center",
        lineHeight: 1.2,
      }}
      gutterBottom
    >
      We invite like-minded people in this region to contribute, participate, 
      and be part of this collective journey toward a better future.
    </Typography>

    <Typography
      variant="body2"
      sx={{
        mt: 2,
        fontSize: { xs: "14px", sm: "16px", md: "18px" }, // Responsive text size
        color: "#000000",
        fontWeight: "600",
        textAlign: "center",
        lineHeight: 1.4,
      }}
      gutterBottom
    >
      எங்கள் முயற்சிகளுக்குப் பின்னால் வழிகாட்டும் சக்தியாக இருக்கிறார்கள், 
      சமூகத்தில் நம்பிக்கையையும் தூண்டுகிறார்கள். சிறந்த எதிர்காலத்தை நோக்கிய 
      இந்த கூட்டு பயணத்தில் பங்கேற்கவும், பங்களிக்கவும் அனைத்து உறுப்பினர்களை 
      எங்களுடன் சேர அழைக்கிறோம்.
    </Typography>

    <Button
  variant="contained"
  sx={{
    backgroundColor: "#FFCC03",
    color: "black",
    fontWeight: "bold",
    mt: 3,
    borderRadius: "50px",
    px: { xs: 3, sm: 4 },
    py: 1,
    fontSize: { xs: "14px", sm: "16px" },
    "&:hover": {
      backgroundColor: "gold",
    },
  }}
  onClick={() => {
    navigate("/register");
    window.scrollTo(0, 0);
  }}
>
  JOIN US!
</Button>

  </Box>
</Box>


{/* FAQ Section */}

<Box id="faq-section" sx={{ backgroundColor: "#f8f9e9", py: 6, top: "150px", bottom: "50px" }}>
   {/* Yellow Shape - Positioned Absolutely */}
  <Box
  sx={{
    position: "absolute",
    top: "20",
    left: "0",
    width: "200px", 
    height: "500px",
    backgroundImage: `url(${sq})`,
    backgroundSize: "contain", 
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
  }}
/>

      <Container>
        <Grid container spacing={4} alignItems="left">
          {/* Left Content Section */}
          <Grid item xs={12} md={6}>
            <Typography variant="h3" sx={{ fontWeight: "700", color: "red", textAlign: "left", fontSize: "50px"  }}>
              Frequently Asked <span style={{ color: "#FAD707" }}><br  />Questions</span>
            </Typography>

            <Typography
              variant="body1"
              sx={{ mt: 2, fontSize: "18px", color: "#000000", lineHeight: 1.8, textAlign: "left", fontWeight: "400" }}
            >
              Got questions? Our FAQ section has answers to the most common inquiries about our services, policies, and more.
              Browse through to find quick, helpful information, and if you need further assistance, feel free to reach out to us directly!
            </Typography>
          </Grid>

          {/* Right Accordion Section */}
          <Grid item xs={12} md={6}>
          <Box sx={{ backgroundColor: "#f8f9e9", width: "100%", py: 6, px: 3, borderRadius: "12px" }}>
      {[
        { 
          question: "What is TKS?", 
          answer: "TKS stands for THIRUKADAIYUR SENAITHALAIVAR CHARITABLE Trust, a non-profit organization dedicated to serving the community through various charitable initiatives and social welfare activities." 
        },
        { 
          question: "What is the role of TKS Trust?", 
          answer: "The role of TKS Trust is to work towards the betterment of society by promoting education, healthcare, cultural preservation, and social welfare programs. It also focuses on supporting the underprivileged and fostering community development." 
        },
        { 
          question: "What is the main goal of TKS Trust?", 
          answer: "The main goal of TKS Trust is to uplift society by addressing pressing issues such as education, healthcare, and community welfare, ensuring sustainable growth and a better quality of life for all." 
        },
        { 
          question: "What's next in TKS?", 
          answer: "To ensure collective progress, we request members to register as a New Member through our online portals: www.tkstrust.org and www.tkstrust.com.", 
          isNavigation: true // Mark this as a navigation item
        },
      ].map((faq, index) => (
        <Accordion 
          key={index} 
          sx={{ backgroundColor: "#f8f9e9", mb: 1, borderRadius: "12px", boxShadow: 3 }}
          onClick={() => {
            if (faq.isNavigation) {
              navigate("/whatsnext");
              window.scrollTo({ top: 0, behavior: "smooth" }); 
            }
          }} 
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography 
              variant="body1" 
              sx={{ fontWeight: "400", fontSize: "18px", color: "#000000", textAlign: "left" }}
            >
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography 
              variant="body2" 
              sx={{ fontWeight: "200", fontSize: "18px", color: "#000000", textAlign: "justify" }}
            >
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
</Grid>
        </Grid>
      </Container>
    </Box>

    {/* Render Contact Us Section */}
    <Box id="contact-section"sx={{ backgroundColor: "#f8f9e9", py: 0, top: "150px", bottom: "150px" }}>
      <Container>
        <Grid container spacing={4} alignItems="center">
          {/* Left Content Section */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: "700",
                color: "red",
                textAlign: "left",
                fontSize: "50px",
              }}
            >
              Contact <span style={{ color: "#FAD707" }}>Us</span>
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "18px",
                color: "#000000",
                lineHeight: 1.8,
                textAlign: "left",
                fontWeight: "400",
              }}
            >
              Need Help? Fill out the form, and we'll get back to you!
            </Typography>

            <Box
              component="img"
              src={contact}
              alt="Contact Us"
              sx={{
                width: "100%",
                borderRadius: "8px",
                boxShadow: 3,
                mt: 2,
              }}
            />

            <Typography
              variant="body2"
              sx={{
                mt: 2,
                fontSize: "18px",
                color: "#000000",
                lineHeight: 1.8,
                textAlign: "left",
                fontWeight: "400",
              }}
            >
              <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc" }}>
                <li>
                  For those interested in joining our community and contributing to our
                  mission.
                </li>
                <li>For individuals who wish to make a donation to support our initiatives.</li>
                <li>For assistance with issues related to money transfers or donations.</li>
              </ul>
            </Typography>
          </Grid>

          {/* Success Snackbar */}
          <Snackbar
  open={openSnackbar}
  autoHideDuration={3000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: "top", horizontal: "center" }} // 👈 Positioned at the top
>
  <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: "100%" }}>
    Form Submitted Successfully!
  </Alert>
</Snackbar>

{/* Error Snackbar */}
<Snackbar
  open={errorSnackbar}
  autoHideDuration={3000}
  onClose={() => setErrorSnackbar(false)}
  anchorOrigin={{ vertical: "top", horizontal: "center" }} // 👈 Positioned at the top
>
  <Alert onClose={() => setErrorSnackbar(false)} severity="error" sx={{ width: "100%" }}>
    Submission Failed! Please try again.
  </Alert>
</Snackbar>
          {/* Contact Form */}
          <Grid item xs={12} md={6}>
            <Box component="form" sx={{ backgroundColor: "#f8f9e9", padding: 4, borderRadius: "8px", boxShadow: 3 }} onSubmit={handleSubmit}>
              <Typography variant="h5" sx={{ fontWeight: "600", color: "#333", mb: 2, textAlign: "center" }}>
                Get in Touch
              </Typography>

              <TextField
      fullWidth
      label="Name*"
      name="name"
      value={formData.name}
      onChange={handleChange}
      inputProps={{ maxLength: 50, pattern: "[A-Za-z ]*" }}
      onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
      error={!!errors.name}
      helperText={errors.name || ""}
      sx={{ mb: 2 }}
    />

    {/* Phone & Email Fields */}
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Phone Number*"
          name="phone"
          type="tel"
          value={formData.phone}
          onChange={handleChange}
          error={!!errors.phone}
          helperText={errors.phone || ""}
          inputProps={{ maxLength: 10 }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Email Address*"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email || ""}
        />
      </Grid>
    </Grid>

    {/* Location Field */}
    <TextField
      fullWidth
      label="Location*"
      name="location"
      value={formData.location}
      onChange={handleChange}
      error={!!errors.location}
      helperText={errors.location || ""}
      sx={{ my: 2 }}
    />

    {/* Message Field */}
    <TextField
      fullWidth
      label="Message"
      name="message"
      multiline
      rows={4}
      value={formData.message}
      onChange={handleChange}
      sx={{ mb: 2 }}
    />
              {/* Submit Button */}
              <Button type="submit" variant="contained" sx={{ backgroundColor: "#FAD707", color: "#000", fontWeight: "bold" }}>
                Submit
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
</Box>
  );
}
export default Home;
